import { useQuery } from '@tanstack/react-query';

import { ThemeValue } from '@/common/components/Theme/Theme';
import { DEFAULT_SETTINGS, QueryKey, StorageKey } from '@/common/utils/constants';
import storage from '@/common/utils/storage';

/**
 * The `Settings` are user preferences.
 * @param theme - The application theme.
 * @param [updatedAt] - Optional. The timestamp the settings were last updated.
 */
export interface Settings {
  theme: ThemeValue;
  updatedAt?: string;
}

/**
 * An API hook which fetches the user `Settings`.
 * @returns Returns a `UseQueryResult` with `Settings` data.
 */
export const useGetSettings = () => {
  const getSettings = (): Promise<Settings> => {
    return new Promise((resolve, reject) => {
      try {
        const storedSettings = storage.getJsonItem<Settings>(StorageKey.Settings, DEFAULT_SETTINGS);
        const settings = {
          ...DEFAULT_SETTINGS,
          ...storedSettings,
        };
        return resolve(settings);
      } catch (err) {
        return reject(err);
      }
    });
  };

  return useQuery({
    queryKey: [QueryKey.Settings],
    queryFn: getSettings,
  });
};
